import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as dayjs from 'dayjs';
import { Appointment, AppointmentState } from '../../model/appointment-book.models';
import { alert } from 'devextreme/ui/dialog';
import { SessionContextService } from 'src/app/services/session-context.service';
import { EditSessionDelaysComponent, SessionDelay } from '../edit-session-delays/edit-session-delays.component';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-appointment-time',
  templateUrl: './appointment-time.component.html',
  styleUrls: ['./appointment-time.component.css']
})
export class AppointmentTimeComponent implements OnChanges {

  ShowAttend = true;
  ShowCancel = true;
  AptStateDesc = '';
  disableDateTime = false;

  DisableSessionDelayEditing = false;

  @Input() aptTime: Date;
  @Input() aptState: AppointmentState = AppointmentState.New;
  @Input() aptLocked:boolean =false;

  private defaultPreSessionDelay: number = 3;
  private defaultPostSessionDelay: number = 3;
  private preSessionDelay: number = 3;
  @Input() set PreSessionDelay(t: number) {    
    this.preSessionDelay = t;
    this.changeDetectorRef.detectChanges();
  }
  get PreSessionDelay(): number {    
    if (!(this.preSessionDelay || this.preSessionDelay === 0))
      return this.defaultPreSessionDelay;      
    else
      return this.preSessionDelay;
  }

  private postSessionDelay: number = 3;
  @Input() set PostSessionDelay(t: number) {
    this.postSessionDelay = t;
    this.changeDetectorRef.detectChanges();
  }
  get PostSessionDelay(): number {
    if (!(this.postSessionDelay || this.postSessionDelay === 0))
      return this.defaultPostSessionDelay;
    else
      return this.postSessionDelay;
  }

  @Output() onDateTimeChanged: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() onAttendAppointment: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancelAppointment: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUpdateSessionDelays: EventEmitter<SessionDelay> = new EventEmitter<SessionDelay>();

  @ViewChild(EditSessionDelaysComponent) dlgSessionDelays: EditSessionDelaysComponent;

  constructor(private session: SessionContextService, private changeDetectorRef: ChangeDetectorRef) {    
    this.defaultPreSessionDelay= this.session.defaultData.defData.customerSettings.PreSessionDelay;
    this.defaultPostSessionDelay= this.session.defaultData.defData.customerSettings.PostSessionDelay;
    this.Reset();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['aptTime']) {
      {
        switch (this.aptState) {
          case AppointmentState.New: this.AptStateDesc = 'New Appointment'; break;
          case AppointmentState.Booked: this.AptStateDesc = 'Appointment<br/>Booked'; break;
          case AppointmentState.Attended: this.AptStateDesc = 'Appointment<br/>Attended'; break;
          case AppointmentState.Paid: this.AptStateDesc = 'Appointment<br/>Paid'; break;
          case AppointmentState.InProgress: this.AptStateDesc = ' Appointment<br/>In Progress'; break;
          case AppointmentState.Completed: this.AptStateDesc = 'Appointment<br/>Completed'; break;
        }
      }
    }
    this.update();
  }

  update() {
    this.disableDateTime = (this.aptState > AppointmentState.Booked);
    this.ShowAttend = Appointment.CanAttendEx(this.aptState, this.aptTime);
    this.ShowCancel = Appointment.CanCancelEx(this.aptState, this.aptTime, this.session.defaultData.defData.customerSettings);
    this.DisableSessionDelayEditing = (this.aptState > AppointmentState.Paid);
  }

  Reset() {
    this.aptState = AppointmentState.New;
    this.aptTime = ConstantsService.MakeDateTimeGMT(new Date());
    this.preSessionDelay = this.defaultPreSessionDelay;
    this.postSessionDelay = this.defaultPostSessionDelay;
    this.update();
  }

  valueChanged(e) {
    const d = new Date(e.value);
    if (dayjs(d) < dayjs()) {
      this.aptTime = dayjs().add(5, 'm').toDate();
      alert('An appointment cannot be booked in the past', 'Invalid date and time');
    }
    else {
      this.onDateTimeChanged.emit(d);
    }
  }

  btnCancelApt(e) {
    this.onCancelAppointment.emit();
  }

  btnAttendApt(e) {
    this.onAttendAppointment.emit();
  }

  disabledDates(e): boolean {
    const today = dayjs().startOf('day').toDate();
    return (e.date < today);
  }

  SessionDelays(e) {    
    var sessionDelay: SessionDelay = new SessionDelay();
    sessionDelay.preSessionDelay = this.PreSessionDelay;
    sessionDelay.postSessionDelay = this.PostSessionDelay;    
    this.dlgSessionDelays.show(sessionDelay);    
  }

  SessionDelaysClosed(e: SessionDelay) {
    if (e.save) {
      this.onUpdateSessionDelays.emit(e);
    }
  }
}